module.exports = __webpack_public_path__ + "img/icon运动员等级_职工一级@3x.7b99166c.png";